/**
 * Date-extensions locale Sindhi [sd]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sd', {
    monthNames: ['جنوري','فيبروري','مارچ','اپريل','مئي','جون','جولاءِ','آگسٽ','سيپٽمبر','آڪٽوبر','نومبر','ڊسمبر'],
    monthShortNames: ['جنوري','فيبروري','مارچ','اپريل','مئي','جون','جولاءِ','آگسٽ','سيپٽمبر','آڪٽوبر','نومبر','ڊسمبر'],
    dayNames: ['آچر','سومر','اڱارو','اربع','خميس','جمع','ڇنڇر'],
    dayShortNames: ['آچر','سومر','اڱارو','اربع','خميس','جمع','ڇنڇر']
});
